import { z } from 'zod';

export const InputSchema = z.object({
    password: z.string()
});

export type ChangePasswordInput = z.infer<typeof InputSchema>;



